module.exports = __webpack_public_path__ + "static/media/mw.fe0541d2.svg";